export const ROUTE_INFORME_REQUERIMIENTO_IMPORTACIONES = 'importaciones-informes-requerimiento-importaciones'
export const ROUTE_RESUMEN_LIQUIDACIONES_GASTOS = 'importacion:resumen-liquidaciones-gastos'
export const ROUTE_DERECHO_ARANCELARIOS = 'importacion:derecho-arancelarios'
